export default {
	"forexceptcreate": {
		"keywords": "e关键词"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/forexcept/forexcept.js